import { useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Client-side routing swaps the page without touching the scroll position, so
 * following a link from halfway down one page drops you halfway down the next.
 * Mounted once inside the Router; renders nothing.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const action = history.action;

  useLayoutEffect(() => {
    // POP is the back/forward button — a return to a page you have already read,
    // where the position you left is the right one to come back to. It is also the
    // action on first load, where there may be a hash to honour.
    if (action === 'POP') return;

    // main.css sets `scroll-behavior: smooth` on <html>, which would turn this into
    // a long animated ride up from the bottom of an essay. Same override the
    // Spirograph page uses for its own reset.
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    root.style.scrollBehavior = previous;
  }, [pathname, action]);

  return null;
};

export default ScrollToTop;
